<template>
  <div class="homepage-ltr" dir="ltr">
    <Navbar />
    <Banner />
    <KeyFeatures />
    <TailorYourDashboard />
    <Testimonials />
    <OurTeam />
    <FAQ />
    <ContactUs />
    <CTA />
    <LightDarkModeBtn />
  </div>
</template>

<script lang="ts">
import { defineComponent, onBeforeUnmount, onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import Navbar from "@/components/FrontPages/Common/Navbar.vue";
import Banner from "@/components/FrontPages/Home/Banner.vue";
import KeyFeatures from "@/components/FrontPages/Common/KeyFeatures.vue";
import TailorYourDashboard from "@/components/FrontPages/Home/TailorYourDashboard.vue";
import Testimonials from "@/components/FrontPages/Home/Testimonials.vue";
import OurTeam from "@/components/FrontPages/Common/OurTeam.vue";
import FAQ from "@/components/FrontPages/Common/FAQ.vue";
import ContactUs from "@/components/FrontPages/Common/ContactUs.vue";
import CTA from "@/components/FrontPages/Common/CTA.vue";
import LightDarkModeBtn from "@/components/FrontPages/Common/LightDarkModeBtn.vue";

export default defineComponent({
  name: "HomePage",
  components: {
    Navbar,
    Banner,
    KeyFeatures,
    TailorYourDashboard,
    Testimonials,
    OurTeam,
    FAQ,
    ContactUs,
    CTA,
    LightDarkModeBtn,
  },
  setup() {
    const originalDirection = ref("");
    const router = useRouter();

    onMounted(() => {
      document.body.classList.add("padding-0");
      
      // Save original direction and force LTR for home page
      originalDirection.value = document.body.getAttribute("dir") || "ltr";
      document.body.setAttribute("dir", "ltr");
      
      // בדיקה אם יש טוקן לאיפוס סיסמה בכתובת URL
      const hash = window.location.hash;
      console.log('Checking URL hash for password reset token:', hash);
      
      if (hash && hash.includes('access_token=') && hash.includes('type=recovery')) {
        console.log('Found password reset token, redirecting to reset password page');
        // הפנייה לדף איפוס הסיסמה עם שימור הטוקן
        router.push('/authentication/reset-password' + hash);
      }
    });
    
    onBeforeUnmount(() => {
      document.body.classList.remove("padding-0");
      
      // Restore original direction when leaving home page
      document.body.setAttribute("dir", originalDirection.value);
    });
  },
});
</script>

<style scoped>
.homepage-ltr {
  direction: ltr !important;
  text-align: left !important;
}

.homepage-ltr * {
  direction: ltr !important;
}
</style>
